import Avatar from "./Avatar.vue";
import Checkbox from "./Checkbox.vue";
import ColorPicker from "./ColorPicker.vue";
import Combobox from "./Combobox.vue";
import CurrencyInput from "./CurrencyInput.vue";
import DateInput from "./DateInput.vue";
import Field from "./Field.vue";
import FileInput from "./FileInput.vue";
import FontPicker from "./FontPicker.vue";
import Input from "./Input.vue";
import Label from "./Label.vue";
import RadioGroup from "./RadioGroup.vue";
import RadioItem from "./RadioItem.vue";
import Select from "./Select.vue";
import Switcher from "./Switcher.vue";
import Textarea from "./Textarea.vue";
import TimeInput from "./TimeInput.vue";
import Toggle from "./Toggle.vue";
import UrlInput from "./UrlInput.vue";

export type { ComboboxOption } from "./Combobox.vue";
export type { SelectOption } from "./Select.vue";
export type { SwitcherMode } from "./Switcher.vue";

export default {
  Avatar,
  Checkbox,
  ColorPicker,
  Combobox,
  CurrencyInput,
  DateInput,
  Field,
  FileInput,
  FontPicker,
  Input,
  Label,
  RadioGroup,
  RadioItem,
  Select,
  Switcher,
  Textarea,
  TimeInput,
  Toggle,
  UrlInput,
};
